<script>
// import { services } from '@src/utils/common-services'
export default {
  props: {
    uid: {
      type: String,
      default() {
        return ''
      },
    },
    token: {
      type: String,
      required: true,
    },
    reset: {
      type: Boolean,
      default() {
        return false
      },
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      newPassword: null,
      oldPassword: null,
      trySpinPassword: false,
      showSuccess: null,
      message: null,
      validateOldPassword: null,
      validateNewPassword: null,
    }
  },
  watch: {
    oldPassword(newVal, oldVal) {
      if (newVal !== oldVal) this.validateOldPassword = null
    },
    newPassword(newVal, oldVal) {
      if (newVal !== oldVal) this.validateNewPassword = null
    },
  },
  beforeDestroy() {
    this.$store.commit('jv/clearRecords', { _jv: { type: 'auth' } })
  },
  methods: {
    savePassword(data) {
      this.trySpinPassword = true
      let requestPayload = null

      var regex = /^\S{8,50}$/

      if (
        this.oldPassword !== null &&
        this.oldPassword !== '' &&
        this.newPassword === this.oldPassword
      ) {
        if (regex.test(this.oldPassword)) {
          if (!this.reset) {
            requestPayload = {
              new_password1: this.oldPassword,
              new_password2: this.newPassword,

              _jv: {
                type: 'auth',
              },
            }
            // console.log(sendData)

            this.$store
              .dispatch('jv/post', [
                requestPayload,
                {
                  url: '/auth/password/change',
                  headers: { common: { authorization: 'JWT ' + this.token } },
                },
              ])
              .then((response) => {
                //    this.message = response.data.attribute.detail
                this.trySpinPassword = false
                this.$bvToast.hide('userSettingsToaster')
                this.$emit('login', true)
              })
              .catch((error) => {
                this.message = error.response.data.errors[0].detail
                // this.success = false

                this.trySpinPassword = false

                //   this.message ='The data you have entered is wrong'

                this.$bvToast.show('userSettingsToaster')

                this.showSuccess = false
                var parent = this
                //   this.cancel('modal-password-change', 'reset')
                setTimeout(() => {
                  parent.$bvToast.hide('userSettingsToaster')
                }, 4000)
              })
          } else {
            requestPayload = {
              new_password1: this.oldPassword,
              new_password2: this.newPassword,
              uid: this.uid,
              token: this.token,

              _jv: {
                type: 'auth',
              },
            }
            // console.log(sendData)

            this.$store
              .dispatch('jv/post', [
                requestPayload,
                {
                  url: '/auth/password/reset',
                },
              ])
              .then((response) => {
                //    this.message = response.data.attribute.detail

                this.$bvToast.hide('userSettingsToaster')
                this.$emit('login', true)
              })
              .catch((error) => {
                this.message = error.response.data.errors[0].detail
                // this.success = false

                this.trySpinPassword = false

                //   this.message ='The data you have entered is wrong'

                this.$bvToast.show('userSettingsToaster')

                this.showSuccess = false
                var parent = this
                //   this.cancel('modal-password-change', 'reset')
                setTimeout(() => {
                  parent.$bvToast.hide('userSettingsToaster')
                }, 4000)
              })
          }
        } else {
          this.trySpinPassword = false
          this.validateOldPassword = 'The password field format is invalid.'
        }
      } else {
        this.trySpinPassword = false
        if (this.oldPassword === null || this.oldPassword === '') {
          this.validateOldPassword = 'Please enter valid data for password'
        }
        if (this.newPassword !== this.oldPassword) {
          this.validateNewPassword =
            'Please enter same password in confirm password'
        }
      }
    },
  },
}
</script>
<template>
  <div>
    <!-- <p>Password reset</p>
    Password:<input v-model="password" type="password" /> confirm
    password:<input v-model="confirmPassword" type="confirmPassword" />
    <button
      @click="
        passwordReset({
          password: password,
          confirm: confirmPassword,
          reset: true,
        })
      "
      >Reset</button
    > -->

    <section :class="$style.loginSection">
      <b-container fluid>
        <b-container>
          <b-row
            :class="[$style.rowAlign]"
            class="align-items-center justify-content-center"
          >
            <b-col cols="12" md="10" lg="8" :class="$style.userLoginWraper">
              <b-row>
                <div class="FL w35 w100-sm" :class="$style.loginLeft">
                  <div :class="$style.contextWraper">
                    <div :class="[$style.contentWrap, $style.tc, $style.mt20]">
                      <img
                        src="@assets/images/logoD-white.png"
                        alt="Application Logo"
                      />
                    </div>
                    <div :class="$style.contextImage">
                      <img
                        src="@assets/images/loginBg.png"
                        alt="Content Image"
                      />
                    </div>
                    <div :class="$style.contentSlider">
                      <p
                        >Committed to giving every child and young person the
                        future they deserve.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="FL w65 w100-sm" :class="$style.loginLeft">
                  <div :class="$style.loginWraper">
                    <div :class="$style.logoWraper" class="w60 w100-sm FR">
                      <img
                        src="@assets/images/logoD.png"
                        alt="Application Logo"
                      />
                      <h5 class="mt20 mb0-sm">{{ title }}</h5>
                    </div>
                    <div class="clear"></div>
                    <form
                      :class="$style.form"
                      data-vv-scope="reset"
                      @submit.prevent="savePassword('reset')"
                    >
                      <div
                        :class="$style.formGroup"
                        class="formGroup mt20 mt10-sm"
                      >
                        <div class="formFieldWrap">
                          <label
                            :class="$style.fieldTitle"
                            class="w40 w100-sm FL pr15 pr0-sm"
                            >New Password</label
                          >
                          <div class="form-field w60 w100-sm FL">
                            <div :class="$style.inputField">
                              <input
                                v-model="oldPassword"
                                name="old password"
                                type="password"
                              />
                              <span
                                v-if="validateOldPassword !== null"
                                :class="$style.error"
                                >{{ validateOldPassword }}</span
                              >
                              <span :class="$style.infoText"
                                >Password must contain atleast 8 characters,
                                combination of UPPER/lowercase and
                                numbers.</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="clear"></div>
                      <div
                        :class="$style.formGroup"
                        class="formGroup mt20 mt10-sm"
                      >
                        <div class="formFieldWrap">
                          <label
                            :class="$style.fieldTitle"
                            class="w40 w100-sm FL pr15 pr0-sm"
                            >Confirm Password</label
                          >
                          <div class="form-field w60 w100-sm FL">
                            <div :class="$style.inputField">
                              <input
                                v-model="newPassword"
                                name="new password"
                                type="password"
                              />
                              <span
                                v-if="validateNewPassword !== null"
                                :class="$style.error"
                                >{{ validateNewPassword }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="clear"></div>
                      <div :class="[$style.buttonWrapper]" class=" mt25">
                        <button
                          class="buttonCommon buttonPrimary button"
                          type="submit"
                          v-on="$listeners"
                        >
                          <b-spinner
                            v-if="trySpinPassword"
                            style="width: 18px; height: 18px;"
                            class="ml15 mr15"
                            label="Spinning"
                          ></b-spinner>
                          {{ !trySpinPassword ? 'Update' : '' }}
                        </button>
                      </div>
                    </form>
                    <div class="clear"></div>
                  </div>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </section>
    <div :class="$style.toasterMainWrap">
      <b-toast id="userSettingsToaster" solid no-auto-hide b-toaster-top-right>
        <div
          class="d-flex"
          :class="
            showSuccess
              ? [$style.loginToasterWraper, $style.success]
              : [$style.loginToasterWraper, $style.error]
          "
        >
          <div :class="$style.toasterLeft">
            <BIcon
              icon="chat-square-dots-fill"
              :class="$style.toasterIcon"
            ></BIcon>
          </div>
          <div :class="$style.toasterRight">
            <strong class="mr-auto" :class="$style.toasterHeader"
              >Notice!</strong
            >
            <p :class="$style.toasterContent">{{ message }}</p>
          </div>
          <div class="clear"></div>
        </div>
      </b-toast>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.loginSection {
  position: relative;
  z-index: 99;
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  background-image: url('~@assets/images/login-bg.png');
  background-repeat: repeat;
}

.rowAlign {
  z-index: 99;
  min-height: 100vh;
}

.contextWraper {
  position: relative;
  height: 100%;
  padding: 30px;
  background: #f15d22;
}

.loginWraper {
  z-index: 99;
  padding: 50px;
}

.infoText {
  display: block;
  font-size: 11px;
  font-style: italic;
  line-height: 14px;
  color: #8c959f;
}

.contextImage {
  margin: 30px 0;

  img {
    width: 100%;
    max-width: 554px;
    height: auto;
  }
}

.contentWrap {
  img {
    width: 80px;
    height: auto;
    margin: 0 auto;
  }
}

.contentSlider {
  p {
    margin: 10px 0;
    font-family: 'SourceSansProLight', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 17px;
    line-height: 20px;
    color: #fff;
    text-align: center;
  }
}

.userLoginWraper {
  width: 100%;
  margin: 20px 0;
  overflow: hidden;
  background: #fff;
  border: 1px solid #ecebeb;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);

  h5 {
    font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 20px;
    color: $primary-color;
  }
}

.logoWraper {
  img {
    width: 100px;
    margin-top: 10px;
  }
}

@media only screen and (max-width: 767px) {
  .contextWraper {
    display: none;
  }

  .loginWraper {
    padding: 30px;
  }

  .logoWraper img {
    width: 80px;
  }

  .userLoginWraper h5 {
    font-size: 20px;
  }
}
</style>
